import Isotope from 'vueisotope';

export default {
  components: {
    Isotope,
  },
  data() {
    return {
      isotopeOptions: {
        itemSelector: '.grid-item',
        layoutMode: 'masonry',
      },
    };
  },
  computed: {
    loadingPhotosByParams() {
      return this.$store.getters.LOADING_PHOTOS_BY_PARAMS;
    },
    sets() {
      if (this.pricelists) {
        let pricelists = this.pricelists[this.album.shop_pricelist_id]
            ? this.pricelists[this.album.shop_pricelist_id].pricelist_sets
            : [];

        if (pricelists.length > 0) {
          pricelists = pricelists.filter(pricelist => +pricelist.show_in_album);
        }

        return pricelists;
      }

      return [];
    },
    orderedPhotos() {
      return this.$store.getters.ORDERED_PHOTOS;
    },
  },
  methods: {
    selectPhoto(id) {
      this.$router.push(this.i18nLink(
          `album/gallery/${this.getAlbumId()}/order/${id}`));
    },
    selectSet(set) {
      this.$router.push({hash: '#set'}).catch(() => {});
      this.$store.dispatch('SET_SET', set);
      this.$store.dispatch('SET_REPLACED_PHOTO_PRODUCT', false);
    },
    getAlbumId() {
      return this.album.status === '2'
          ? `${this.album.hash}-${this.album.hash_password}`
          : this.album.id;
    },
    isFavorite(id) {
      const albumIndex = this.favorites ? this._.findIndex(this.favorites,
          {albumId: this.album ? this.album.id : 0}) : 0;

      if (albumIndex >= 0) {
        return this.favorites ? !!this._.find(this.favorites[albumIndex].items,
            {photoId: id}) : false;
      }

      return false;
    },
  },
};
